import { BaseEditViewStore, BaasicDropdownStore } from "core/stores";
import { WoundOrderService } from "../services";
import { action } from "mobx";
import { FacilityService } from "application/facility/services";
import { WoundOrderEditForm } from "application/wound-order/forms";
import { applicationContext } from "core/utils";

@applicationContext
class WoundOrderEditViewStore extends BaseEditViewStore {
    form = new WoundOrderEditForm({
        onSubmit: async (form) => {
            await this.onSubmit(form.values());
        },
    });
    params = {
        id: this.rootStore.routerStore.routerState.params.id,
    };

    constructor(rootStore) {
        const service = new WoundOrderService(
            rootStore.application.baasic.apiClient
        );
        const facilityService = new FacilityService(
            rootStore.application.baasic.apiClient
        );

        const id = rootStore.routerStore.routerState.params.id;
        super(rootStore, {
            name: "wound-order",
            id: id,
            Form: WoundOrderEditForm,
            authorization: "portalSection.update",
            actions: {
                get: async (id, opts) => {
                    const response = await service.get(id, opts);
                    return response.data;
                },
                update: async (resource) => {
                    const response = await service.update(resource);
                    return response.data;
                },
                create: async (resource) => {
                    const response = await service.create(resource);
                    return response.data;
                },
            },
            FormClass: WoundOrderEditForm,
        });

        this.service = service;

        this.facilityStore = new BaasicDropdownStore(
            {
                filterable: true,
            },
            {
                fetchFunc: async (term) => {
                    const response = await facilityService.find({
                        searchQuery: term,
                        rpp: 10,
                        inActive: false,
                    });
                    return response.data.item;
                },
            }
        );
    }

    @action.bound
    async onSubmit(resource) {
        const woundOrderService = new WoundOrderService(
            this.rootStore.application.baasic.apiClient
        );
        const response = await woundOrderService.create(resource);
        window.location.replace(
            this.rootStore.routerStore
                .findRoute("master.app.main.wound-order.add-wound-dressing")
                .pattern.replace(":id", response.data.id)
        );
        return response.data;
    }
}

export default WoundOrderEditViewStore;
